<template>
<div v-if="!video.settings.live" class="card px-3 py-4 w-100">
    <h1 class="m-auto">
        {{ $t('lesson.live.unavailable') }}
    </h1>
    <h3 class="mx-auto" v-if="video.settings.start_date">
        {{ $t('lesson.live.start_at') }}: {{ $moment(video.settings.start_date).format('LLL') }}
    </h3>
</div>
<Player v-else-if="video && url" :video="url"/>
</template>

<script>
import Player from './ClassPlayer';
import { NCH_ENV } from '../../../../../../js/nch-env';

export default {
    emits: ['input', 'update:modelValue', 'value'],
    name: 'ContentLive',
    components: {
        Player,
    },

    props: {
        modelValue: Object,
    },

    computed: {
        user() {
            return this.$store.getters.USER;
        },
        url() {
            return `${this.video.type_video}/${this.video.secret}`;
        },
        live: {
            get() {
                return {
                    room_id: this.video.settings.id,
                    name: `NCH_LV_${this.video.settings.id}`,
                    status: this.video.settings.chat,
                    history: this.video.settings.chat_save,
                    moderate: this.video.settings.chat_mod,
                    type: 'lv',
                };
            },
            set(settings) {
                this.$emit('value', {
                    ...this.video,
                    settings: {
                        room_id: settings.id,
                        name: `NCH_LV_${settings.id}`,
                        status: settings.chat,
                        history: settings.chat_save,
                        moderate: settings.chat_mod,
                        type: 'lv',
                    },
                });
            },

        },
        video: {
            get() { return this.modelValue; },
            set(value) { this.$emit('value', value); },
        },
    },

    methods: {
        subscribe() {
            window.Echo
                .private(`${NCH_ENV.APP_HOST}.Lesson.Live.${this.video.settings.id}`)
                .listen('LiveLessonEvent', (e) => {
                    if (e.settings) {
                        this.live = e.settings;
                    }
                });
        },
    },

    watch: {
        'video.settings.id': {
            handler(value) {
                this.subscribe();
            },
        },
    },

    mounted() {
        this.subscribe();
    },
};
</script>

<style>

</style>
